import { CircularProgress } from "@mui/material";

function CircularLoading({ size }: { size: number }) {
  return (
    <CircularProgress
      size={size}
      sx={(theme) => ({
        color: "#009c4e",
        ...theme.applyStyles('dark', {
          color: "#009c4e",
        }),
      })} />
  );
}

export default CircularLoading;